import { NgModule } from '@angular/core';
import { ParticlesModule } from 'angular-particle';


import { ParticleBackgroundDirective } from './directives/background';
import { mathRandom } from './constants';

@NgModule({
    imports: [
        ParticlesModule,
    ],
    declarations: [
        ParticleBackgroundDirective,
    ],
    providers: [
        {
            provide: 'Math',
            useValue: {
                random: mathRandom,
            },
        },
    ],
    exports: [
        ParticleBackgroundDirective,
    ],
})

export class ParticleModule {}
